<div class="footer">
  <div class="ui container center aligned">
    <div class="ui horizontal list">
      <div class="item middle aligned">
        <img src="/assets/logo-simple.svg" alt="FIT Logo" class="footer-logo">
      </div>
      <div class="item middle aligned" i18n="@@footer-fit">
        FIT für die Wissenschaft
      </div>
      <div class="item middle aligned">
        <a class="link" href="https://www.uni-kassel.de/go/fit" target="_blank" i18n="@@footer-fit-network">
          FIT-Netzwerk
        </a>
      </div>
      <div class="item middle aligned">
        <a class="link" href="https://www.uni-kassel.de" target="_blank">Uni Kassel</a>
      </div>
      <div class="item middle aligned">
        <a class="link" routerLink="/privacy" target="_blank" i18n="@@footer-privacy">Datenschutz</a>
      </div>
      <div class="item middle aligned">
        <a class="link" routerLink="/contact" target="_blank" i18n="@@imprint">Impressum</a>
      </div>
      <div class="item middle aligned">
        <a class="link" routerLink="/contact" target="_blank" i18n="@@contact">Kontakt</a>
      </div>
    </div>
  </div>
</div>
